// extracted by mini-css-extract-plugin
export default {"title":"PageNotFound_title__t8qTn","container":"PageNotFound_container__8ZVjG"};